import { EnvironmentProviders, Provider } from '@angular/core';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_GESAMTABFRAGE } from './gesamtabfrage.permissions';
import {
  GesamtabfrageConfig,
  SOFTLINE_CONFIG_GESAMTABFRAGE,
} from './gesamtabfrage.shared';

import { gesamtabfrageQueryDefinition } from './definitions/gesamtabfrage-query.definition';
import { default as listDefaultDefinition } from './definitions/gesamtabfrage-list.definition.json';
import { default as businessCaseDefaultDefinition } from './definitions/business-case-list.definition.json';
import {
  SOFTLINE_DEFINITION_VOUCHER_BUSINESS_CASE,
  SOFTLINE_DEFINITION_VOUCHER_LIST,
  SOFTLINE_DEFINITION_VOUCHER_QUERY,
} from './gesamtabfrage.api';
import { SOFTLINE_CONFIG_DEFINITION } from '@softline/dynamic';
import { BelegDownloadStrategy } from './commands/download/beleg-download.strategy';
import { ArchivbelegDownloadStrategy } from './commands/download/archiv-beleg-download.strategy';
import { DatentraegerDownloadStrategy } from './commands/download/datentraeger-download.strategy';
import { FremdbelegDownloadStrategy } from './commands/download/fremd-beleg-download.strategy';
import { provideSoftAppsModule, withSoftAppsModuleTranslation } from '@softapps/core';

export function provideGesamtabfrage(
  config?: GesamtabfrageConfig
): Array<EnvironmentProviders | Provider> {
  const returnValue = [...gesamtabfrageProviders];
  if (config) {
    returnValue.push({
      provide: SOFTLINE_CONFIG_GESAMTABFRAGE,
      useValue: config,
    });
  }
  return returnValue;
}

export const gesamtabfrageProviders: Array<EnvironmentProviders | Provider> = [
  provideSoftAppsModule(
    {
      name: '#GESAMTABFRAGE.TITLE',
      title: '#GESAMTABFRAGE.TITLE',
      icon: 'fa-regular fa-file-invoice',
      route: '/gesamtabfrage',
      permission: SOFTLINE_PERMISSION_GESAMTABFRAGE,
    },
    withSoftAppsModuleTranslation({ de })
  ),
  BelegDownloadStrategy,
  FremdbelegDownloadStrategy,
  ArchivbelegDownloadStrategy,
  DatentraegerDownloadStrategy,
  {
    provide: SOFTLINE_CONFIG_GESAMTABFRAGE,
    useValue: { download: [BelegDownloadStrategy] },
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_VOUCHER_QUERY,
      definition: gesamtabfrageQueryDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_VOUCHER_LIST,
      definition: listDefaultDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_VOUCHER_BUSINESS_CASE,
      definition: businessCaseDefaultDefinition,
    },
    multi: true,
  },
];
